import { forwardRef } from "preact/compat";
import type { ForwardedRef } from "preact/compat";
import en from "./flags/en.svg?no-inline";
import sv from "./flags/sv.svg?no-inline";

const flags: Record<string, string> = { sv, en };

interface Props {
    language: string;
    className?: string;
}

const SIZE = "1em";

export const Flag = forwardRef(
    ({ language, className }: Props, ref: ForwardedRef<SVGSVGElement>) => {
        const flag = flags[language];
        return (
            <svg ref={ref} width={SIZE} height={SIZE} className={className}>
                <use href={`${flag}#${language}`} />
            </svg>
        );
    },
);

Flag.displayName = "Flag";
